import React from 'react';
import Navbar from '../../components/navbar';
import FormularioDatosTrabajador from '../../formData/formularioDatosTrabajador';

function DatosTrabajador() {
  return (
    <FormularioDatosTrabajador />
  )
}

export default DatosTrabajador;
